
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.64.594C4.12 2.188 3.095 3.479 2.564 4.469c-.532.99-.797 2.015-.797 3.078 0 .5.07.9.21 1.203.146.297.342.526.587.688.25.156.674.302 1.273.437.703.151 1.172.346 1.406.586.235.24.352.557.352.953 0 .552-.2 1.06-.602 1.524-.4.468-.956.942-1.664 1.421l-.46-.554c.952-.688 1.429-1.367 1.429-2.04 0-.307-.073-.515-.219-.624-.14-.104-.49-.22-1.047-.344-1.094-.23-1.82-.604-2.18-1.125-.354-.526-.53-1.18-.53-1.961 0-.99.288-1.99.867-3 .583-1.016 1.554-2.162 2.914-3.438v-.078H.766V.211H5.64v.383z","fill":"currentColor"}})])
          )
        }
      }
    